/// <amd-module name="Environments/Providers/Kubernetes/PageData" />
import { ResourceErrorType } from "Environments/Providers/External/Kubernetes/Contracts/Contracts";
import { IKubernetesResourceDetails, IKubernetesSummary } from "Types";
import { IVssObservableService, Services, VssObservableService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const kubernetesSummaryDataProviderId = "ms.vss-environments-web.kubernetes-summary-data-provider";
const KubernetesResourceDataProviderId = "ms.vss-environments-web.kubernetes-resource-data-provider";

export interface IKubernetesDataService extends IVssObservableService<IKubernetesSummary> {
    getKubernetesSummaryData(): IKubernetesSummary;
    getKubernetesResourceData(): IKubernetesResourceDetails | undefined;
    getResourceErrorType(): ResourceErrorType;
}

class KubernetesDataService extends VssObservableService<IKubernetesSummary> implements IKubernetesDataService {
    public getKubernetesSummaryData(): IKubernetesSummary {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getData<IKubernetesSummary>(kubernetesSummaryDataProviderId) || {} as IKubernetesSummary;
    }

    public getKubernetesResourceData(): IKubernetesResourceDetails | undefined {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getData<IKubernetesResourceDetails>(KubernetesResourceDataProviderId);
    }

    public getResourceErrorType(): ResourceErrorType {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        const providerExceptions = contributionService.getDataProviderExceptions();
        if (providerExceptions) {
            const ex = providerExceptions[kubernetesSummaryDataProviderId];
            if (ex && ex.exceptionType) {
                switch (ex.exceptionType) {
                    case "ServiceEndpointNotFoundException":
                    case "EnvironmentResourceNotFoundException":
                        return ResourceErrorType.Deleted;
                }

                // for any other issue, revalidate
                return ResourceErrorType.AccessDenied;
            }
        }

        return ResourceErrorType.None;
    }
}

Services.add("IKubernetesDataService", { serviceFactory: KubernetesDataService });